/*
 * Proprietary and Confidential
 *
 * Copyright (c) [2018] -  [] Marcelo H. Krebber - Munich, London 2018
 * All Rights Reserved.
 *
 * Dissemination or reproduction of this file [simple-editable-box.js] or parts within
 * via any medium is strictly forbidden unless prior written permission is obtained
 * from <marcelo.krebber@gmail.com>
 *
 * Last modified: 28.02.19 13:23
 */

import React, {useState} from 'react';
import {RoundedButton} from "../navigation/buttons/nav-buttons";
import {NavigationGroup, NavigationRow} from "../navigation/layout/nav-layout";
import {useLanguage} from "../configuration/configuration";
import {
    AddPhotoIcon,
    fs_bigger,
    fs_regular,
    SendIcon,
    SoundcloudBrandIcon,
    VideoUploadIcon,
    YoutubeSquareIcon
} from "../navigation/icons/nav-icons";
import {EditorMarkdownTextarea} from "../toggler/form-markdown-textarea";
import {useAuthorization} from "../../selectors";

/**
 * standard post editor with media upload and markdown support
 */
const MarkdownTextEditor = ({text, callback, mediaupload, youtube, videoUpload, soundcloud}) => {
    const [editorData, setEditorData] = useState(text || '');
    const {isSuperUser, isAdmin} = useAuthorization();
    const Lang = useLanguage();

    const handleOnEnter = event => {
        event.preventDefault();
        callback(editorData);
        setEditorData("")
    };

    const handleOnChange = event => {
        setEditorData(event.target.value);
    };

    return <div className='markdown-text-editor'>
            <NavigationRow>
                <EditorMarkdownTextarea name="editablebox"
                                  placeholder={Lang.post.editor.placeholder}
                                  value={editorData}
                                  rows='3'
                                  maxLength='8096'
                                  onChange={handleOnChange}/>
            </NavigationRow>

            <NavigationRow className='mt-1'>
                <NavigationGroup>
                    {mediaupload && <RoundedButton className=' btn-outline-secondary p-1 mr-1' title={Lang.post.editor.uploadImageTooltip}
                                   onClick={mediaupload}>
                        <AddPhotoIcon size={fs_regular} aria-hidden="true"/>
                    </RoundedButton>}

                    {(isSuperUser || isAdmin) && <>
                        {videoUpload && <RoundedButton className='btn-outline-secondary p-1 mr-1'
                                                       title={Lang.post.editor.uploadVideoTooltip}
                                                       onClick={videoUpload}>
                            <VideoUploadIcon size={fs_regular} aria-hidden="true"/>
                        </RoundedButton>}

                        {youtube && <RoundedButton className='btn-outline-secondary p-1 mr-1'
                                       title={Lang.post.editor.youTubeTooltip} onClick={youtube}>
                            <YoutubeSquareIcon size={fs_bigger} aria-hidden="true"/>
                        </RoundedButton>}

                        {soundcloud && <RoundedButton className='btn-outline-secondary p-1' title={Lang.post.editor.soundcloudTooltip}
                                       onClick={soundcloud}>
                            <SoundcloudBrandIcon size={fs_regular} aria-hidden="true"/>
                        </RoundedButton>}
                    </>}
                </NavigationGroup>

                <NavigationGroup >
                    <RoundedButton className='btn-primary p--10 mr-1' title={Lang.post.editor.saveTooltip}
                                   onClick={handleOnEnter}>
                        <SendIcon size={fs_bigger} aria-hidden="true" className='clr-white'/>
                    </RoundedButton>
                </NavigationGroup>
            </NavigationRow>
        </div>
}

export default MarkdownTextEditor;

